module.exports = __webpack_public_path__ + "static/media/great-clean-logo.3c645a95.png";